import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button, Input, List, Avatar, Image } from "antd";
import UserLogin from "./forms/UserLogin";
import { PersonLinesFill, HouseFill, FilePostFill, Activity, Globe2, SaveFill } from 'react-bootstrap-icons';
import DefaultNav from "./navbars/DefaultNav";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var HomeContent = function HomeContent() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "login-page-container",
      style: {
        margin: "0px 0px"
      },
      children: [/*#__PURE__*/_jsx(DefaultNav, {}), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            lg: {
              span: 12
            },
            md: {
              span: 12
            },
            sm: 12,
            style: {
              display: "flex",
              justifyContent: "center"
            },
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsxs("div", {
                className: "home-right-box",
                style: {
                  width: "38%",
                  minWidth: "370px"
                },
                children: [/*#__PURE__*/_jsx(Image, {
                  preview: false,
                  src: "drawables/emgl.png",
                  width: "80px"
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UserLogin, {}), /*#__PURE__*/_jsx("div", {
                  className: "hlogo"
                })]
              })
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsx("br", {})]
  });
};
export default HomeContent;